export default "__VITE_ASSET__CgWSPchy__"